export default __webpack_public_path__ + "static/media/logoPokemon.aa7f630b.png";